export enum DemoInvoiceView {
  Editor = 'editor',
  Preview = 'preview',
}
